export const projects = [
    {
        title: 'MSA Basketball 2D',
        picture: 'images/MSA2D.png',
        video: 'videos/msa2d.mp4',
        technologies: 'XREngine, Three.js, Ecs, React',
        description: 'A web-based basketball stats simulator featuring a 3D gameplay demo and an in-browser asset editor.' +
            ' Developed using a custom-built engine (XREngine) leveraging ECS architecture, React, and Three.js.' +
            ' The platform enables users to simulate, visualize, and edit game statistics in an immersive, interactive 3D environment.'
    },
    {
        title: 'Multiplayer Race',
        picture: 'images/MultiplayerRace.png',
        video: 'videos/Multiplayer_Race.mp4',
        technologies: 'React-three-fiber, Three.js, Typescript, Xstate, Node.js, Socket.io',
        description: 'A real-time educational multiplayer racing game focused on collaborative learning.' +
            ' Built with React Three Fiber, Three.js, TypeScript, XState for state management,' +
            ' and powered by a Socket.io-based multiplayer backend.'
    },
    {
        title: 'Wild Capture Agency',
        picture: 'images/WildCaptureAgency.png',
        technologies: 'WebGL, Three.js, React, Node.js',
        description: 'A technically complex integration of volumetric video into web environments for a leading video studio.' +
            ' The project pushed the boundaries of video rendering performance and interactivity within browsers using WebGL and Three.js.'
    },
    {
        title: 'Lego education platform',
        picture: 'images/Lego.png',
        technologies: 'PHP, Javascript, Three.js',
        description: 'A fully web-based educational platform that allows users to build and interact with LEGO models directly in the browser' +
            ' - functionality previously only seen in native desktop apps. Built with PHP, JavaScript, and Three.js.'
    },
    {
        title: 'Light Co-Lab',
        picture: 'images/LightCo-Lab.png',
        technologies: 'WebGL, Three.js, Vue.js, PHP',
        description: 'A 3D product showroom built for an Australian lighting company,' +
            ' enabling customers to explore and visualize lighting products interactively.' +
            ' Built with Vue.js, WebGL, PHP, and Three.js.'
    },
    {
        title: 'ARC',
        picture: 'images/ARC.png',
        video: 'videos/arc.mp4',
        technologies: 'Vuforia, Capacitor',
        description: 'An innovative mobile and web application that integrates volumetric video capture of artists using Vuforia for AR and Capacitor for cross-platform support.' +
            ' The solution was wrapped and deployed as a native iOS and Android app.' +
            ' Technologies included Swift, Kotlin, and web-based rendering layers.'
    }
];


